<template>
    <div>
      <main>
          <list />
      </main>
    </div>
  </template>
  
  <script>    
  import list from "@/components/client/templates/list";
  
  export default {
    components: {
      list,
    },
  };
  </script>
  
  <style lang="scss" scoped>
  </style>